import { type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

export type ActionProps = {
  onCancel: () => void;
  onConfirm: () => void;
  onClear: () => void;
  hasExisting: boolean;
  disabled: boolean;
  pending: boolean;
};

function ClearBtn({
  onClick,
  pending,
}: {
  onClick: () => void;
  pending: boolean;
}): ReactNode {
  return (
    <Button variant="danger" size="sm" onClick={onClick} disabled={pending}>
      Quitar vacaciones
    </Button>
  );
}

export function Actions(p: ActionProps): ReactNode {
  return (
    <div className="flex justify-end gap-sm">
      <Button
        variant="ghost"
        size="sm"
        onClick={p.onCancel}
        disabled={p.pending}
      >
        Cancelar
      </Button>
      {p.hasExisting && <ClearBtn onClick={p.onClear} pending={p.pending} />}
      <Button
        variant="primary"
        size="sm"
        onClick={p.onConfirm}
        disabled={p.disabled || p.pending}
      >
        Marcar vacaciones
      </Button>
    </div>
  );
}
